<template>
  <div class="serie fade-in-fast">
    <router-link :to="{ name: 'Serie', params: { id: serieData.permlink } }">
      <div class="serie__image">
        <div class="serie__image__tagline">
          <span>SERIES</span>
        </div>
        <picture class="serie__image__thumb-container">
          <img
            class="serie__image__thumb-container__thumb"
            :src="$router.options.imagePath + serieData.imageUrl"
          />
        </picture>
      </div>
      <div class="serie__data">
        <div class="serie__data__wrapper">
          <div class="serie__data__header">
            <span>STEGI.RADIO</span>
          </div>
          <div class="serie__data__heading">
            <div class="serie__data__heading__title">
              {{ serieData.title }}
            </div>
            <!-- <div class="serie__data__heading__subtitle">
              <span>w/</span>
              <span>{{ serieData.artistName }}</span>
            </div> -->
            <div v-if="false" class="serie__data__heading__frequency">
              {{ serieData.subTitle }}
            </div>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'SerieCard',
  props: {
    serieData: { type: Object, required: true, default: () => {} }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_serie-card.scss';
</style>
